import * as React from "react";
import PropTypes from "prop-types";

import { useSiteMetadata } from "../hooks/useSiteMetadata";

const Seo = ({
    meta = [],
    page,
    defaultTitle,
    seoDescription,
    seoRobots,
    seoKeywords,
}) => {
    const { siteDescription, siteTitle } = useSiteMetadata();
    const title = defaultTitle || page?.seoTitle || siteTitle;
    const description =
        seoDescription ||
        page?.seoDescription?.seoDescription ||
        siteDescription;
    const robotsValue = seoRobots || page?.seoRobots || !page;
    const robots = robotsValue ? "index, follow" : "noindex, nofollow";
    const keywords = seoKeywords || "";

    return (
        <>
            <title>{title}</title>
            <meta charSet="utf-8" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:creator" content="ShiftMed.com" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="robots" content={robots} />
            <meta name="keywords" content={keywords} />
            {meta?.map(metaProperties => (
                <meta {...metaProperties} />
            ))}
        </>
    );
};

Seo.propTypes = {
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            property: PropTypes.string,
            name: PropTypes.string,
            content: PropTypes.string.isRequired,
        })
    ),
    page: PropTypes.shape({
        seoTitle: PropTypes.string,
        seoDescription: PropTypes.shape({
            seoDescription: PropTypes.string,
        }),
        seoRobots: PropTypes.bool,
    }),
    defaultTitle: PropTypes.string,
    seoDescription: PropTypes.string,
    seoRobots: PropTypes.bool,
    seoKeywords: PropTypes.string,
};

export default Seo;
